import { render, staticRenderFns } from "./whApproval.vue?vue&type=template&id=78d94b69&scoped=true&"
import script from "./whApproval.vue?vue&type=script&lang=js&"
export * from "./whApproval.vue?vue&type=script&lang=js&"
import style0 from "./whApproval.vue?vue&type=style&index=0&id=78d94b69&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78d94b69",
  null
  
)

export default component.exports